var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Marker, useHEREMap } from '@tenderd/track-web-utils';
import { Button, Form, Input, Modal, Row } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import React, { useEffect } from 'react';
import { GroupGeofenceMode, useGroupGeofencePageContext, } from '../../../GroupGeofencePage.context';
import './LocationMarkers.style.css';
import DeleteLocationMarker from './components/DeleteLocationMarker';
import useLocationMarkers from './useLocationMarkers';
export var LocationMarkers = function (props) {
    var _a, _b;
    var hook = useLocationMarkers();
    var context = useGroupGeofencePageContext();
    var locationId = useWatch('_id', hook.form);
    var map = useHEREMap().map;
    var handleMapClick = function (lat, lon) {
        if (context.contextModeRef.current === GroupGeofenceMode.AddLocation) {
            hook.form.setFieldsValue(__assign(__assign({}, hook.defaultValues), { location: {
                    lat: lat,
                    lon: lon,
                } }));
            hook.setModal(true);
        }
    };
    useEffect(function () {
        if (!map)
            return;
        var tapFn = function (evt) {
            var coord = map.screenToGeo(evt.currentPointer.viewportX, evt.currentPointer.viewportY);
            handleMapClick(coord.lat, coord.lng);
        };
        map.addEventListener('tap', tapFn, false);
        return function () {
            map.removeEventListener('tap', tapFn, false);
        };
    }, [map]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { width: 380, open: hook.modal, closable: false, title: "".concat(locationId ? 'Update' : 'Add', " Location Marker"), centered: true, rootClassName: "location-marker-modal", footer: [
                React.createElement(React.Fragment, null,
                    React.createElement(Row, { align: 'middle', wrap: false },
                        React.createElement(Button, { style: { width: '100%' }, key: "submit", type: "primary", loading: hook.loading, onClick: hook.form.submit }, locationId ? 'Save Changes' : 'Add'),
                        React.createElement(Button, { style: { width: '100%' }, key: "back", disabled: hook.loading, onClick: function () { return hook.setModal(false); } }, "Cancel")),
                    React.createElement(DeleteLocationMarker, { onSuccess: function () {
                            hook.setModal(false);
                        }, locationId: locationId })),
            ] },
            React.createElement(Form, { form: hook.form, onFinish: hook.onSubmit, requiredMark: false, layout: "vertical", initialValues: hook.defaultValues },
                React.createElement(Form.Item, { name: "_id", hidden: true }),
                React.createElement(Form.Item, { name: "location", hidden: true }),
                React.createElement(Form.Item, { name: "name", label: "Name", labelCol: {
                        span: 0,
                    }, rules: [{ required: true }] },
                    React.createElement(Input, { placeholder: "Location", size: "large" })))), (_b = (_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a.locationMarkers) === null || _b === void 0 ? void 0 :
        _b.map(function (lM, index) {
            return (React.createElement(Marker, { lat: lM.location.lat, lng: lM.location.lon, key: index, onClick: function () {
                    hook.LMRef.current = lM;
                    hook.setModal(true);
                }, data: lM },
                React.createElement("div", { className: "machine-marker" },
                    React.createElement("div", { style: {
                            position: 'relative',
                            height: 60,
                            width: 60,
                        } },
                        React.createElement("div", { className: "overlay" }),
                        React.createElement("div", { className: "machine-marker-icon" },
                            React.createElement("img", { style: { height: 20, width: 20 }, src: "https://tenderd-ui.storage.googleapis.com/assets/landmark.png" })),
                        React.createElement("img", { alt: "direction indicator", src: "https://storage.googleapis.com/tenderd-ui/assets/direction-indicator-black.png", className: "machine-marker-direction-indicator", style: {
                                filter: 'invert(31%) sepia(40%) saturate(5751%) hue-rotate(347deg) brightness(117%) contrast(81%)',
                            } })))));
        })));
};
